<template>
  <div>
    <v-row>
      <v-col cols="12">
        <gg-card>
          <gg-card-header>
            Create Protected URL
          </gg-card-header>
          <gg-card-text>
            <create-protected-url  @url-created="reloadList" />
          </gg-card-text>
        </gg-card>
      </v-col>
      <v-col cols="12">
        <protected-urls-list ref="list" />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import ProtectedUrlsList from '@/components/Services/Hosting/ProtectedUrls/ProtectedUrlsList'
import CreateProtectedUrl from '@/components/Services/Hosting/ProtectedUrls/CreateProtectedUrl'

export default {
  name: 'ProtectedUrls',
  components: {
    ProtectedUrlsList,
    CreateProtectedUrl
  },
  methods: {
    reloadList () {
      this.$refs.list.loadCurrent()
    }
  }
}
</script>
